<template>
  <section
    id="toimitustapa"
    class="section"
  >
    <h2
      id="shipping-method"
      class="section__heading section__heading--alt2"
    >
      3. {{ $modeoL10n.choose_shipping_method }}
    </h2>
    <div
      v-if="showError"
      class="error-notification"
    >
      {{ $modeoL10n.shipping_method_required }}
    </div>
    <div class="checkout__rows">
      <template
        v-for="(shippingMethod) in shippingMethodsForView"
      >
        <div
          :key="shippingMethod.id + '-label'"
          class="checkout__header"
        >
          <label class="checkout__header__field">
            <input
              v-model="selectedShippingMethod"
              type="radio"
              name="shipping_method[0]"
              :value="shippingMethod.id"
              class="radio-input"
              @change="shippingMethodChanged()"
            >
            <span class="checkout__header__heading radio-label">{{ shippingMethod.label }}</span>
            <span
              v-if="shippingMethod.method_id == 'free_shipping'"
              class="checkout__header__price"
            >
              <price
                :price-without-tax="shippingMethod.cost"
                :price-with-tax="shippingMethod.cost_with_tax"
              />
            </span>
            <span
              v-if="shippingMethod.method_id != 'free_shipping'"
              class="checkout__header__price checkout__header__price--with-tax"
            >
              <price
                :price-without-tax="shippingMethod.cost"
                :price-with-tax="shippingMethod.cost_with_tax"
              />
              <span class="checkout__header__tax tax">{{ $modeoL10n.vat }} {{ $store.getters.displayVat }}</span>
            </span>
            <span class="checkout__header__detail">
              <template v-if="shippingMethod.method_id == 'free_shipping'">{{ cartDeliveryTime }} - {{ cartDeliveryTime + 1 }} {{ $modeoL10n.weeks }}</template>
              <template v-if="shippingMethod.method_id == 'flat_rate'">{{ cartDeliveryTime }} - {{ cartDeliveryTime + 1 }} {{ $modeoL10n.weeks }}</template>
              <template v-if="shippingMethod.method_id == 'local_pickup'">{{ cartDeliveryTime }} {{ $modeoL10n.weeks }}</template>
            </span>
          </label>
        </div>

        <div
          v-if="shippingMethod.method_id == 'free_shipping' && selectedShippingMethod && selectedShippingMethod.includes('free_shipping')"
          :key="shippingMethod.id + '-free-shipping'"
          class="checkout__subsection"
        >
          <div class="grid-wrap">
            <div class="grid-col bp3-col-one-half">
              <p v-if="address">
                <template v-if="address.first_name || address.last_name">
                  {{ address.first_name }} {{ address.last_name }}<br>
                </template>
                <template v-if="address.company">
                  {{ address.company }}<br>
                </template>
                <template v-if="address.address_1">
                  {{ address.address_1 }},
                </template>
                <template v-if="address.postcode || address.city">
                  {{ address.postcode }} {{ address.city }}<br>
                </template>
                <template v-if="address.phone">
                  {{ address.phone }}<br>
                </template>
                <template v-if="address.email">
                  {{ address.email }}
                </template>
              </p>
              <div class="checkout__subsection__form">
                <label for="order_comments">{{ $modeoL10n.delivery_info }}</label>
                <textarea
                  id="order_comments"
                  name="order_comments"
                  rows="3"
                  class="input-text"
                />
              </div>
            </div>
            <div class="grid-col bp3-col-one-half">
              <p>{{ $modeoL10n.delivery_help1 }}</p>
              <p>{{ $modeoL10n.delivery_help2 }}</p>
              <p class="checkout__small-print">
                {{ $modeoL10n.delivery_help3 }}
              </p>
            </div>
          </div>
        </div>

        <div
          v-if="shippingMethod.method_id == 'flat_rate' && selectedShippingMethod && selectedShippingMethod.includes('flat_rate')"
          :key="shippingMethod.id + '-flat-rate'"
          class="checkout__subsection"
        >
          <div class="grid-wrap">
            <div class="grid-col bp3-col-one-half">
              <p v-if="address">
                <template v-if="address.first_name || address.last_name">
                  {{ address.first_name }} {{ address.last_name }}<br>
                </template>
                <template v-if="address.company">
                  {{ address.company }}<br>
                </template>
                <template v-if="address.address_1">
                  {{ address.address_1 }},
                </template>
                <template v-if="address.postcode || address.city">
                  {{ address.postcode }} {{ address.city }}<br>
                </template>
                <template v-if="address.phone">
                  {{ address.phone }}<br>
                </template>
                <template v-if="address.email">
                  {{ address.email }}
                </template>
              </p>
              <div class="checkout__subsection__form">
                <label for="order_comments">{{ $modeoL10n.delivery_info }}</label>
                <textarea
                  id="order_comments"
                  name="order_comments"
                  rows="3"
                  class="input-text"
                />
              </div>
            </div>
            <div class="grid-col bp3-col-one-half">
              <p>{{ $modeoL10n.delivery_help1 }}</p>
              <p>{{ $modeoL10n.delivery_help2 }}</p>
              <p class="checkout__small-print">
                {{ $modeoL10n.delivery_help3 }}
              </p>
            </div>
          </div>
        </div>

        <div
          v-if="shippingMethod.method_id == 'local_pickup' && selectedShippingMethod && selectedShippingMethod.includes('local_pickup')"
          :key="shippingMethod.id + '-pickup'"
          class="checkout__subsection"
        >
          <p>{{ $modeoL10n.pickup }} {{ allProductsAreInOutlet ? outletWarehouseAddress : mainWarehouseAddress }}.</p>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
    import _ from 'lodash';

    export default {
        props: {
            mainWarehouseAddress: {
                type: String,
                default: '',
            },
            outletWarehouseAddress: {
                type: String,
                default: '',
            },
        },
        data : function () {
            return {
                selectedShippingMethod: null,
                hasFreeShipping: false,
            };
        },
        computed: {
            subtotal: function() {
                return this.$store.getters.getTotals.subtotal;
            },
            billingAddress: function() {
                return this.$store.getters.getBillingAddress;
            },
            shippingAddress: function() {
                return this.$store.getters.getShippingAddress;
            },
            cartDeliveryTime: function() {
                return this.$store.getters.getCartDeliveryTime;
            },
            shippingMethods: function() {
                return this.$store.getters.getShippingMethods;
            },
            allProductsAreInOutlet: function() {
                return this.$store.getters.getAllProductsAreInOutlet;
            },
            /* Combines needed info from billing and shipping address */
            address: function() {

                if (typeof this.shippingAddress !== 'undefined' && this.shippingAddress.useForShipping) {
                    let address = _.clone(this.shippingAddress.address);
                    address.company = this.billingAddress.address.company;
                    address.email = this.billingAddress.address.email;
                    address.phone = this.billingAddress.address.phone;
                    return address;
                } else if (typeof this.billingAddress !== 'undefined'){
                    return this.billingAddress.address;
                } else {
                    return false;
                }
            },
            shippingMethodsForView: function() {
                let shippingMethods =  _.values(this.shippingMethods);
                let hasFreeShipping = shippingMethods.some(shippingMethod => shippingMethod.method_id === 'free_shipping');
                // deselect flat_rate or free_shipping when the option is removed
                if (this.hasFreeShipping !== hasFreeShipping) {
                    this.toggleFreeShipping(hasFreeShipping);
                    if (this.selectedShippingMethod && !this.selectedShippingMethod.includes('local_pickup')) {
                        this.resetSelectedShippingMethod();
                    }
                }
                if (hasFreeShipping) {
                    return shippingMethods.filter(shippingMethod => shippingMethod.method_id !== 'flat_rate');
                }
                return shippingMethods;
            },
            showError: function() {
                return (this.$store.getters.getCheckoutSubmitClicked && this.selectedShippingMethod === null)
            },
        },
        created: function () {
            this.shippingMethodChanged();
        },
        methods: {
            shippingMethodChanged: function() {
                this.$store.commit('setShippingMethod', this.shippingMethods[this.selectedShippingMethod]);
            },
            resetSelectedShippingMethod: function() {
                this.selectedShippingMethod = null;
                this.shippingMethodChanged();
            },
            toggleFreeShipping: function(hasFreeShipping) {
                this.hasFreeShipping = hasFreeShipping;
            },
        },
    }
</script>
